import { render, staticRenderFns } from "./SwitchIcon.vue?vue&type=template&id=fe6348ba&scoped=true"
import script from "./SwitchIcon.vue?vue&type=script&lang=js"
export * from "./SwitchIcon.vue?vue&type=script&lang=js"
import style0 from "./SwitchIcon.vue?vue&type=style&index=0&id=fe6348ba&prod&scoped=true&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "fe6348ba",
  null
  
)

export default component.exports